<template>
  <div>
    <v-navigation-drawer
      v-if="!$loginState.noAccess && qaActions.length > 1 && $loginState.ui_layout !== 'V2'"
      v-model="menu"
      app
      temporary
      width="300"
      class="no-print"
      style="z-index:21"
    >
      <v-list class="pb-0">
        <v-list-item class="logo">
          <v-list-item-avatar>
            <img
              width="40"
              height="40"
              src="@/assets/rolemapper-icon-new.png"
              alt="RM"
            />
          </v-list-item-avatar>
          <v-list-item-title>
            <img
              height="25"
              src="@/assets/rolemapper-headline.png"
              alt="RoleMapper"
            />
            <v-btn icon aria-label="Close Navigation Menu" class="float-right" style="margin-top: -7px" @click="menu = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-list-item-title>
        </v-list-item>
      </v-list>

      <v-list nav dense class="menu" ref="navMenu">
        <div v-for="n in menuItems" :key="n.name">
          <v-list-item class="pl-2 ml-0" :class="n.text.split(' ').join('')" link v-if="!n.subItems" :to="n">
            <v-list-item-icon>
              <v-icon :class="n.iconClass">{{ n.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ n.text }}</v-list-item-title>
          </v-list-item>
          <v-list-group v-else :prepend-icon="n.icon" v-model="n.expanded">
            <template v-slot:activator>
              <v-list-item-title>{{ n.text }}</v-list-item-title>
            </template>
              <v-list-item
                class="pl-2 ml-0"
                link
                v-for="si in n.subItems"
                :key="si.name"
                :to="si"
              >
                <v-list-item-icon>
                  <v-icon :class="si.iconClass">{{ si.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ si.text }}</v-list-item-title>
              </v-list-item>
          </v-list-group>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      flat
      dense
      class="no-print" :class="$loginState.ui_layout === 'V2' ? 'v2ui-application-header' : ''"
      v-if="$loginState.isAuthenticated"
    >
      <v-app-bar-nav-icon
        v-if="!$loginState.noAccess && qaActions.length > 1 && $loginState.ui_layout !== 'V2'"
        @click="menu = !menu"
        class="mr-2"
        title="Navigation Menu"
        :aria-expanded="menu.toString()"
      />
      <v-btn
        v-if=" $loginState.ui_layout !== 'V2' &&
          $vuetify.breakpoint.smAndUp &&
          $loginState.user.createDocumentDialogOptions.length &&
          !($route.name === 'home' || $route.meta.hideHeaderCreate)
        "
        :title="'Create New ' + ($loginState.user.createDocumentDialogOptions.length === 1 ? $loginState.user.createDocumentDialogOptions[0].tmpl_name : 'Document')"
        @click="$emit('addDocument')"
        color="primary"
        small
        outlined
        v-testid="'create-new-document'"
      >
        <span>Create</span>
        <!-- <v-icon>mdi-plus</v-icon> -->
      </v-btn>
      <v-avatar
        v-if="$loginState.ui_layout === 'V2'"
        color="white"
        size="36"
        class="rm-home-logo"
        title="Home"
        role="button"
        tabindex="0"
        @click="goHome"
        @keydown.enter="goHome"
      ><span class="rm-header-avatar-text">RM</span></v-avatar>

      <v-toolbar-title v-if="$loginState.ui_layout === 'V2'" class="rm-header-title-text ml-2">
        {{ toolbarTitle }}
      </v-toolbar-title>
      <v-toolbar-title v-else-if="$vuetify.breakpoint.smAndUp" class="ml-0 pl-4">
        {{ toolbarTitle }}
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        v-if="$loginState.ui_layout === 'V2' &&
          $vuetify.breakpoint.smAndUp &&
          $loginState.user.createDocumentDialogOptions.length &&
          !($route.name === 'home' || $route.meta.hideHeaderCreate)
        "
        :title="'Create New ' + ($loginState.user.createDocumentDialogOptions.length === 1 ? $loginState.user.createDocumentDialogOptions[0].tmpl_name : 'Document')"
        @click="$emit('addDocument')"
        color="#2f6bff" class="white--text v3-hdr-btn"
        small
        v-testid="'create-new-document'"
      >Create
      </v-btn>
      <!--
        Cross-portal switch (trial). Session carries over without any
        token handoff: auth lives in the httpOnly RMAPI_RT cookie on the
        API domain, and the beta portal re-mints its JWT via
        auth/loginstate/ on load — so this is a plain navigation. Gated
        on the beta_portal_access client setting AND a build-time URL
        (envs with no beta deployment leave VUE_APP_BETA_PORTAL_URL
        unset, hiding the button).
      -->
      <v-btn
          v-if="betaPortalUrl()"
          small
          class="betaSwitchBtn v3-hdr-btn"
          title="Switch to the new RoleMapper portal"
          @click="switchToBetaPortal"
        >
          Try the new portal
        </v-btn>
      <v-btn
          small :color="$loginState.ui_layout === 'V2' ? '#4B5563' : '#DB0066' "
          class="userPilotFeedbackBtn v3-hdr-btn" @click="triggerFeedback"
        >
          Feedback
        </v-btn>
      <v-toolbar-title class="ml-0 pr-4" :class="$loginState.ui_layout === 'V2' ? 'rm-header-title-label' : 'clientName'" v-if="showClient">{{
        $loginState.user.client
      }}</v-toolbar-title>
      <v-toolbar-items>
        <template v-if="$loginState.permittedRoutes.includes('notificationlist')">
        <v-badge v-if="activity.message"
          content="3"
          :color="activity.overdue_tasks ? 'red' : activity.due_tasks ? 'amber' : 'blue'" dot 
          offset-x="20" offset-y="20">
          <v-btn icon @click="openActivity" :title="activity.message">
            <v-icon>mdi-bell-outline</v-icon>
          </v-btn>
        </v-badge>
        <v-btn v-else icon @click="openActivity" title="Notifications and Tasks">
          <v-icon>mdi-bell-outline</v-icon>
        </v-btn>
        </template>
        <v-btn icon v-if="!showSearch" @click="showSearch = true" title="Search">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-expand-x-transition v-if="showSearch">
          <HeaderSearch
            @close="showSearch = false"
            @openDocument="openDocument"
          />
        </v-expand-x-transition>
        <v-menu
          offset-y
          transition="slide-y-transition"
          v-if="!$loginState.noAccess"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" title="Recent Documents" class="histBtn">
              <v-icon v-if="recentDocs.length">mdi-history</v-icon>
              <v-icon v-else color="grey lighten-2">mdi-history</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              @click="$emit('addDocument')"
              v-if="$loginState.user.createDocumentDialogOptions.length"
            >
              <v-list-item-icon class="mr-3">
                <v-icon>add</v-icon>
              </v-list-item-icon>
              <v-list-item-title
                >Create New
                {{
                  $loginState.user.createDocumentDialogOptions.length === 1
                    ? $loginState.user.createDocumentDialogOptions[0].tmpl_name
                    : "Document"
                }}</v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="subtitle-1"
                >Recently Viewed</v-list-item-title
              >
            </v-list-item>
            <v-list-item
              v-for="d in recentDocs"
              :key="d.id"
              @click="$emit('openDocument', d)"
            >
              <v-list-item-icon class="mr-3">
                <v-avatar class="jobTypeAvatar" size="25">
                  <span class="subtitle-2">{{ getAbbreviation(d.type) }}</span>
                </v-avatar>
              </v-list-item-icon>
              <v-list-item-title>
                <span v-html="d.id.substring(3, 12) + ' - ' + d.title"></span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-if="$zendesk.isEnabled"
          :title="$zendesk.isVisible && $zendesk.isOpen ? 'Hide Help' : 'Request Help'"
          icon
          @click="$zendesk.toggle()"
        >
          <v-icon class="outlined">live_help</v-icon>
        </v-btn>


        <!--
          Atlas entry point. Shared component (AtlasFlyoutButton) owns
          the click handler (toggle), the green/grey connection-state
          colouring, the suppressed-on-/agent disable, and the auto
          tooltip. Same component is used in cDocumentFullNEW.vue's
          toolbar so both surfaces stay visually + behaviourally
          identical.
        -->
        <AtlasFlyoutButton v-if="utils.atlasFlyoutAvailable($loginState)" :size="22" :pill="$loginState.ui_layout === 'V2'" />
        <v-btn
          icon
          v-if="
            $loginState.user &&
            $loginState.user.settings.some(
              (s) =>
                s.setting === 'user_settings' && s.value.indexOf('allow') === 0
            )
          "
          @click.stop="$emit('openUserSettings')"
          title="Settings"
          :aria-expanded="settingsExpanded.toString()"
        >
          <v-icon title="Settings"> settings </v-icon>
        </v-btn>
        <v-menu
          v-model="account"
          offset-y
          transition="slide-y-transition"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon title="Account" v-bind="attrs" v-on="on">
              <v-avatar v-if="$loginState.ui_layout === 'V2'" :color="$loginState.user.background_colour" size="32">
                <span class="rm-user-avatar-text" :style="{ color: $loginState.user.text_colour }">{{ $loginState.user.userInitials }}</span>
              </v-avatar>
              <v-avatar v-else :class="!$loginState.impersonating ? 'secondary-background' : ''" :color="$loginState.impersonating ? 'success darken-2' : ''" size="32">
                <span v-if="$loginState.impersonating" class="white--text body-2">{{ $loginState.user.impersonatedInitials }}</span>
                <span v-else class="body-2">{{ $loginState.user.userInitials }}</span>
              </v-avatar>
              <!-- <v-icon>mdi-account</v-icon> -->
            </v-btn>
          </template>
          <v-card width="450">
            <v-card-text>
              <v-row>
                <v-col class="d-flex align-center justify-space-between">
                  <h2>{{ $loginState.user.client }}</h2>
                  <v-btn v-if="!$loginState.sso" text color="primary" @click="logout">
                    Logout
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="d-flex justify-start">
                  <v-avatar color="primary" dark>
                    <span class="white--text headline">{{ $loginState.user.userInitials }}</span>
                  </v-avatar>
                  <div class="pl-3">
                    <h2 class="mt-1 mb-0">{{ $loginState.user.impersonator_name || $loginState.user.name }}</h2>
                    <p>{{ $loginState.user.impersonator_email || $loginState.user.email }}</p>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="$loginState.impersonating">
                <v-col cols="12" class="d-flex align-center justify-space-between">
                  <h2>Impersonating</h2>
                  <v-btn color="primary" text @click="impersonateRevert">
                    Revert
                  </v-btn>
                </v-col>
                <v-col class="d-flex justify-start">
                  <v-avatar color="success darken-2" dark>
                    <span class="white--text headline">{{ $loginState.user.impersonatedInitials }}</span>
                  </v-avatar>
                  <div class="pl-3">
                    <h2 class="mt-1 mb-0">{{ $loginState.user.name }}</h2>
                    <p>{{ $loginState.user.email }}</p>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="$loginState.canImpersonate">
                <v-col cols="12">
                  <h2> {{ $loginState.impersonating ? $loginState.isInternal ? 'Switch Customer/User' : 'Switch User' : 'Impersonation' }}</h2>
                </v-col>
                <v-col cols="6" v-if="$loginState.isInternal">
                  <v-select
                    v-if="$loginState.isInternal"
                    label="Customer"
                    v-model="customer"
                    :items="customerList"
                    item-text="client_name"
                    return-object
                    dense
                    outlined
                    hide-details
                    ></v-select>
                </v-col>
                <v-col :cols="$loginState.isInternal ? 6 : 12">
                  <v-combobox
                    label="Select User" outlined
                    :items="impersonateUsers"
                    dense
                    item-text="name"
                    item-value="user_id"
                    return-object
                    v-model="impersonateUser"
                    hide-details
                    >
                  </v-combobox>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    label="Reason"
                    outlined
                    v-model="impersonateReason"
                    dense
                    hide-details
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="4" class="d-flex align-center justify-end">
                  <v-btn color="primary"
                    :disabled="!impersonateUser"
                    @click="impersonate"
                    >
                    {{ $loginState.impersonating ? 'Switch' : 'Impersonate' }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn
                text
                small
                @click="account = false; $emit('openCookiePreferences')"
              >
                Cookie preferences
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import HeaderSearch from "@/components/cHeaderSearch";
import AtlasFlyoutButton from "@/components/agent/AtlasFlyoutButton.vue";
import utils from "@/common/utils.js";

let refreshTimeout;

export default {
  name: "HeaderNew",
  components: {
    HeaderSearch,
    AtlasFlyoutButton,
  },
  props: {
    recentDocs: { type: Array, required: true },
    qaActions: { type: Array, required: true },
    settingsExpanded: { type: Boolean, default: false }
  },
  data: function () {
    return {
      menu: false,
      account: false,
      showSearch: false,
      menuItems: [],
      customer: null,
      impersonateUsers: [],
      impersonateUser: null,
      impersonateReason: "",
      useGateway: false,
      messages: 0,
      gatewayLog:false,
      activity: { 
        due_tasks: 0, outstanding_tasks: 0, overdue_tasks: 0, unseen_notifications: 0, message: "",
      },
      utils: utils,
    };
  },
  created() {
    this.menuInit();
    this.getActivityAlertStatus();
  },
  updated() {},
  watch: {
    qaActions() {
      this.menuInit();
    },
    account(val) {
      if (val) {
        this.impersonateUser = null;
        this.impersonateReason = "";
        this.customer = null;

        if (this.$loginState.isInternal)
          this.customer = this.customerList.find(c => c.client_id === this.$loginState.user.client_id);
        
        if (!this.customer)
          this.loadImpersonationUsers();
      }
    },
    customer(val) {
      if (this.$loginState.isInternal
        && val && val.internal_user_id) {
        
        this.loadImpersonationUsers();
        if (this.$loginState.user.user_id !== val.internal_user_id) {
          const internalUser = {
            user_id: val.internal_user_id,
            name: val.internal_user_name
          };
          this.impersonateUser = internalUser;
          this.impersonateUsers.push(internalUser);
        }
      }
    },
    menu(val) {
      if (val) {
        const section = this.menuItems.find(
          (i) => i.name == this.$route.meta.section && i.subItems
        );
        if (section) section.expanded = true;
        setTimeout(() => {
          this.$refs.navMenu?.$el?.querySelector("a.v-list-item--link.v-list-item--active")?.focus();
        }, 200);
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.escKeyHandler);
  },
  destroyed () {
    window.removeEventListener('keydown', this.escKeyHandler);
  },
  computed: {
    getConnectionState(){
      let state = this.$eventGateway.connectionState;
      return state ? "green":"red";
    },
    toolbarTitle: function () {
      if (!this.$loginState.isAuthenticated) return "RoleMapper";
      if (this.$route.meta.dashboardId) return "";
      if (this.$loginState.ui_layout === 'V2') {
        return this.$route.meta?.header_title || this.$route.meta?.text;
      }
      switch (this.$route.name) {
        case "home":
          return this.screenName;
        default:
          return "";
      }
    },
    showClient: function () {
      return (
        this.$vuetify.breakpoint.mdAndUp &&
        this.$loginState.user.client !== "Scottish Parliament" &&
        this.$loginState.user.client !== "Akamai" &&
        this.$loginState.user.client !== "Baker Hughes"
      );
    },
    ...mapState({
      screenName: (state) => state.header.screenName,
      customerList: (state) => state.customers.customerList,
      docTypes: (state) => state.hierarchies.docTypes,
    }),
  },
  methods: {
    // A method, not a computed: $loginState is a plain (non-reactive)
    // object, so a computed caches its first result and never
    // invalidates when impersonation swaps $loginState.user — the
    // button wouldn't appear/disappear until a full reload. Methods
    // re-evaluate on every re-render (same pattern as
    // utils.atlasFlyoutAvailable above).
    betaPortalUrl() {
      const base = (process.env.VUE_APP_BETA_PORTAL_URL || "").replace(/\/+$/, "");
      if (!base || !this.$loginState.user) return "";
      const enabled = (this.$loginState.user.settings || []).some(
        (s) => s.setting === "beta_portal_access" && s.value === "true"
      );
      if (!enabled) return "";
      // /u/<idx> keeps the same profile index selected on the other side
      const idx =
        Number(this.$route.params.user) ||
        this.$loginState.user.impersonatedUserIndex ||
        1;
      return `${base}/u/${idx}`;
    },
    switchToBetaPortal() {
      window.location.href = this.betaPortalUrl();
    },
    triggerFeedback(){
      if(window.userpilot){
        window.userpilot.trigger('survey:f5KzPV_rS5');
      }
    },
    /**
     * Atlas entry point from the header. Routes to the full-page
     * /u/:user/agent surface today. When the AtlasFlyout component
     * is built, swap this to `this.atlasFlyout.toggle()` (or, if the
     * file is converted to use Composition API, call `toggle` from a
     * `useAtlasFlyout()` `setup()` block). The route name is
     * `agentChat` per rm-portal/src/router/index.js.
     */
    openAtlas(){
      this.$router.push({
        name: 'agentChat',
        params: { user: this.$loginState.user.username },
      });
    },
    toggleSearch() {
      if (this.showSearch) {
        this.showSearch = false;
      } else {
        this.showSearch = true;
      }
    },
    openActivity() {
      if (this.$router.currentRoute.name !== 'notificationlist')
        this.$router.push({ name: 'notificationlist' });
    },
    goHome() {
      if (this.$route.name !== 'home')
        this.$router.push({ name: 'home', params: { ...this.$route.params } }).catch(() => {});
    },
    openDocument(doc) {
      this.showSearch = false;
      this.$emit("openDocument", doc);
    },
    getAbbreviation(docType) {
      return this.docTypes.find(dt => dt.tmpl_name === docType)?.docAbbrev || this.getInitials(docType) || "JA";
    },
    getInitials(input) {
      if (!input) return "";

      const names = input.split(" ");
      let initials = names[0].substring(0, 1).toUpperCase();

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      return initials;
    },
    menuInit() {
      if (!this.qaActions || this.qaActions.length == 0)
        this.menuItems.splice(0);

      this.menuItems = this.qaActions
        .filter(
          (a) =>
            !this.$router.menuSections.some((s) => s.name == a.meta.section)
        )
        .map((i) => {
          const iconSplit = i.meta?.icon?.split(" ") || [];
          return {
            name: i.name,
            path: i.path,
            icon: iconSplit[0],
            iconClass: iconSplit.length ? iconSplit[1] : "",
            text: i.meta.text,
          };
        });

      this.$router.menuSections.forEach((s) => {
        const sectionItems = this.qaActions
          .filter((a) => s.name == a.meta.section)
          .map((i) => {
            const iconSplit = i.meta?.icon?.split(" ") || [];
            return {
              name: i.name,
              path: i.path,
              icon: iconSplit[0],
              iconClass: iconSplit.length ? iconSplit[1] : "",
              text: i.meta.text,
            };
          });
        if (sectionItems.length == 1) {
          this.menuItems.push(sectionItems[0]);
        } else if (sectionItems.length > 1) {
          this.menuItems.push({
            name: s.name,
            icon: s.icon,
            iconClass: s.iconClass,
            text: s.name,
            expanded: sectionItems.some((i) => i.name == this.$route.name),
            subItems: sectionItems,
          });
        }
      });

      // Always trigger the gateway connect. Mirrors App.vue
      // connectToGateway() lines 454-456 which already has the same
      // `|| true` fallback flagged with a TODO to remove the legacy
      // `use_event_gateway` setting check. Without this `|| true`
      // here, users whose setting isn't explicitly "true" never emit
      // the connect event up to App.vue — so the gateway never
      // connects, the Atlas button stays grey, document collaboration
      // / presence / live updates all silently fail. Keep these two
      // call sites in sync until the feature flag is retired.
      this.useGateway = this.$loginState.user.settings.some(s => s.setting === 'use_event_gateway' && s.value === 'true') || true;
      if(this.useGateway){
        this.$emit('handleGatewayEvent',"connect");
      }
    },
    escKeyHandler (event) {
      if (event.code === 'Escape') {
        this.menu = false;
      }
    },
    logout() {
      this.account = false;
      this.$emit('logout');
    },
    loadImpersonationUsers() {
      this.impersonateUsers.splice(0);
      axios
        .get(`user/impersonationUsers/${this.customer ? this.customer.client_id : this.$loginState.user.client_id}`)
        .then((resp) => {
          if (resp.data.Status === "OK") {
            this.impersonateUsers.push(...resp.data.Data);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
    impersonate() {
      if (this.impersonateUser && this.impersonateUser.user_id) {
        this.account = false;
        this.$emit("impersonate", {
          impersonateUserId: this.impersonateUser.user_id,
          impersonateReason: this.impersonateReason
        });
      }
    },
    impersonateRevert() {
      this.account = false;
      this.impersonateUser = null;
      this.$emit("impersonateRevert");
    },
    getActivityAlertStatus() {
      this.$store
        .dispatch("tasks/getActivityAlertStatus")
        .then((resp) => {
          if (resp.data.Data.length) {
            this.activity.due_tasks = Number(resp.data.Data[0].due_tasks);
            this.activity.outstanding_tasks = Number(resp.data.Data[0].outstanding_tasks);
            this.activity.overdue_tasks = Number(resp.data.Data[0].overdue_tasks);
            this.activity.unseen_notifications = Number(resp.data.Data[0].unseen_notifications);
            let message = "";
            if (this.activity.outstanding_tasks) 
              message = `${this.activity.outstanding_tasks} outstanding task${this.activity.outstanding_tasks > 1 ? "s" : ""}`;
            if (this.activity.overdue_tasks || this.activity.due_tasks) {
              message += ` (`;
              if (this.activity.overdue_tasks) {
                message += `${this.activity.overdue_tasks} overdue`;
                if (this.activity.due_tasks) message += ", "
              }
              if (this.activity.due_tasks) message += `${this.activity.due_tasks} due today`
              message += `)`;
            }
            if (this.activity.unseen_notifications) {
              if (message.length) message += " and "
              message = `${this.activity.unseen_notifications} unseen notification${this.activity.unseen_notifications > 1 ? "s" : ""}`;
            }
            this.activity.message = message.length ? `You have ${message}` : "";
          }
          //refresh every 3 mins
					refreshTimeout = setTimeout(() => this.getActivityAlertStatus(), 180000);				
        }),
        (error) => {
          if (refreshTimeout)
            clearTimeout(refreshTimeout);
          console.error(error);
					refreshTimeout = setTimeout(() => this.getActivityAlertStatus(), 30000);
        };
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/vars";

.logo {
  min-height: 60px;
  padding: 0 8px;
  .v-list-item__title {
    padding-top: 10px;
    padding-left: 6px;
  }
}
.menu ::v-deep {
  .v-list-group__header.v-list-item--active {
    background-color: transparent !important;
  }
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: #54616c !important;
  }
  .theme--light.v-list-item:not(.v-list-item--active) .v-icon {
    color: #7d93b4;
  }
  .theme--light.v-list-item:focus {
    background-color: #F6F6F6 !important;
  }
}
.clientName {
  font-weight: 600;
  font-size: 0.625rem;
  text-transform: uppercase;
}
.v-application.theme--light {
  .clientName {
    color: $input-icon-color;
  }
}
</style>